/* src/app/burden/burden-presenter/burden-presenter.component.scss */
/*# sourceMappingURL=burden-presenter.component.css.map */
